import React from 'react';
import { connect } from 'react-redux';
import { setActiveLanguage } from 'react-localize-redux';
import Cookies from 'js-cookie';
import moment from 'moment';
import { LANG_COOKIE_NAME, PERSISTENT_COOKIE_LIFETIME } from '../../../constants';
import { withLang, langType } from '../../../i18n';
import styles from '../header.module.css';
import envConfig from '../../../constants/env';

const logoUrls = Object.fromEntries(
  Object.entries(import.meta.glob('../../../images/*.svg', { eager: true, import: 'default' }))
    .map(([file, url]) => [file.match(/([^/]+)\.svg$/)[1], url])
);

const Logo = ({ lang }) => {
  const logoName = envConfig.UNIVERSITY_DETAILS.logo;
  const logoUrl = logoUrls[logoName];
  if (logoUrl === undefined) {
    return (
      <a href={envConfig.UNIVERSITY_DETAILS.universityUrl[lang]} target="_blank" rel="noreferrer">
        <span className={`${logoName} ${styles.smallLogo}`} data-cy="header-logo" />
      </a>
    );
  }
  return (
    <a href={envConfig.UNIVERSITY_DETAILS.universityUrl[lang]} target="_blank" rel="noreferrer">
      <img
        src={logoUrl}
        alt={envConfig.UNIVERSITY_DETAILS.universityTitle}
        className={`${styles.smallLogo}`}
        width="auto"
        data-cy="header-logo"
      />
    </a>
  );
};

Logo.propTypes = {
  ...langType
};

const mapDispatchToProps = (dispatch) => ({
  dispatchSetActiveLanguage: (language) => {
    dispatch(setActiveLanguage(language));
    Cookies.set(LANG_COOKIE_NAME, language, { expires: PERSISTENT_COOKIE_LIFETIME });
    document.documentElement.lang = language;
    moment.locale(language);
  }
});

export default connect(mapDispatchToProps)(withLang(Logo));
